import { RecipeVariantProps, sva } from 'styled-system/css';

const input = sva({
  slots: ['root', 'startAttachment', 'endAttachment'],
  base: {
    root: {
      backgroundColor: {
        base: '#fff',
        _disabled: 'gray-3',
      },
      textStyle: 'b1',
      color: {
        base: 'black-1',
        _disabled: 'black-4',
        _placeholder: 'black-4',
      },
      borderColor: 'black-4',
      caretColor: 'purple-primary',
      borderRadius: '8px',
      width: '100%',
      minHeight: '48px',
      outline: 'none',
      px: '15px',
      border: {
        base: '1px solid {colors.black-4}',
        _focus: '1px solid {colors.purple-3}',
      },
    },
    startAttachment: {
      position: 'absolute',
      start: '0',
      top: '0',
      height: '48px',
    },
    endAttachment: {
      position: 'absolute',
      end: '0',
      top: '0',
      height: '48px',
    },
  },
  variants: {
    isError: {
      true: {
        root: {
          borderColor: 'red',
        },
      },
    },
    startAttachment: {
      small: {
        root: {
          ps: '48px',
        },
        startAttachment: {
          width: '48px',
        },
      },
      medium: {
        root: {
          ps: '70px',
        },
        startAttachment: {
          width: '70px',
        },
      },
      large: {
        root: {
          ps: '100px',
        },
        startAttachment: {
          width: '100px',
        },
      },
    },
    endAttachment: {
      small: {
        root: {
          pe: '48px',
        },
        endAttachment: {
          width: '48px',
        },
      },
      medium: {
        root: {
          pe: '70px',
        },
        endAttachment: {
          width: '70px',
        },
      },
      large: {
        root: {
          pe: '100px',
        },
        endAttachment: {
          width: '100px',
        },
      },
    },
  },
});

export default input;
export type InputVariants = RecipeVariantProps<typeof input>;
